(function () {
  if (window.__faStaffelpreisI18nLoaded) return;
  window.__faStaffelpreisI18nLoaded = true;

  function labels() {
    const nodes = document.querySelectorAll('[data-fa-staffelpreis-i18n]');
    const node = nodes[nodes.length - 1];
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (_error) {
      return null;
    }
  }

  function translatedText(value, dictionary) {
    const leading = (value.match(/^\s+/) || [''])[0];
    const trailing = (value.match(/\s+$/) || [''])[0];
    let text = value.trim();
    if (!text) return value;

    const exact = {
      Staffelpreise: dictionary.heading,
      Menge: dictionary.quantity,
      Preis: dictionary.price,
      Hinweis: dictionary.note,
      'ab Menge': dictionary.fromQuantityGeneric,
    };
    if (exact[text]) return leading + exact[text] + trailing;

    text = text.replace(/^Normalpreis:\s*/, dictionary.regularPrice + ': ');
    text = text.replace(/^ab\s+(?=\d)/, dictionary.fromPrefix);
    text = text.replace(/\bpro VPE\b/g, dictionary.perUnit);
    text = text.replace(/\bVPE\b/g, dictionary.unit);
    text = text.replace(/\s+sparen$/, ' ' + dictionary.saveSuffix);
    return leading + text + trailing;
  }

  function localize() {
    const dictionary = labels();
    if (!dictionary) return;
    document.querySelectorAll('[data-staffelpreis-table]').forEach((root) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const translated = translatedText(node.nodeValue || '', dictionary);
        if (translated !== node.nodeValue) node.nodeValue = translated;
      }
    });
  }

  function start() {
    localize();
    const observer = new MutationObserver(localize);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
